import classNames from "classnames";
import Image, { ImageProps } from "next/image";
import { FC } from "react";
import { useImageComponent } from "./useImage";

interface Props extends Omit<ImageProps, "src"> {
  src: string;
  secondSrcImg?: string;
  fallbackSrcs?: string[];
  aspectRatio?: number;
  className?: string;
  onClick?: () => void;
}

const ImageComponent: FC<Props> = ({
  src,
  secondSrcImg,
  fallbackSrcs,
  alt = "",
  width,
  height,
  aspectRatio = 1,
  className,
  sizes,
  quality,
  fill,
  onClick,
  ...props
}) => {
  const { currentSrc, computedHeight, handleError, isFillImage } =
    useImageComponent({
      src,
      secondSrcImg,
      fallbackSrcs,
      width,
      height,
      aspectRatio,
    });

  if (!currentSrc) {
    return (
      <div
        className="w-full h-full bg-fds-secondary"
        style={{
          width: typeof width === "number" ? `${width}px` : undefined,
          height:
            typeof computedHeight === "number"
              ? `${computedHeight}px`
              : undefined,
        }}
      />
    );
  }

  return (
    <Image
      src={currentSrc}
      alt={alt}
      width={isFillImage || fill ? undefined : (width as number | undefined)}
      height={
        isFillImage || fill ? undefined : (computedHeight as number | undefined)
      }
      fill={isFillImage || fill}
      sizes={fill || isFillImage ? sizes : undefined}
      quality={quality}
      onError={handleError}
      className={classNames(className, onClick && "cursor-pointer")}
      onClick={onClick}
      {...props}
    />
  );
};

export default ImageComponent;
